// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"958f3aabe7045310","3975":"eac96baebbbb3048"}[chunkId] + ".css";
};